import React from "react";

export const ChartMensajesAutomaticosOriginal = ({ data }) => {
    const carteraP = data.find((item) => item.cartera === "P")?.cantidad || 0;
    const carteraV = data.find((item) => item.cartera === "V")?.cantidad || 0;
    const totalMensajes = carteraP + carteraV;
    const mensajesRestantes = 3000 - totalMensajes;
    const porcentajeP = totalMensajes ? ((carteraP / totalMensajes) * 100).toFixed(2) : 0;
    const porcentajeV = totalMensajes ? ((carteraV / totalMensajes) * 100).toFixed(2) : 0;
    return (
        <div className="mensajes-automaticos-container sin-grafica">
            <div className="info-section">
                <div className="total-messages">
                    <h3>Mensajes Disponibles: {mensajesRestantes}</h3>
                </div>
                <div className="total-messages">
                    <h3>Mensajes Enviados: {totalMensajes}</h3>
                </div>
                <div className="details">
                    <div className="detail-item">
                        <span>Vencidos:</span> <span>{carteraV} | {porcentajeV}%</span>
                    </div>
                    <div className="detail-item">
                        <span>Por Vencer:</span> <span>{carteraP} | {porcentajeP}%</span>
                    </div>
                </div>
            </div>
        </div>
    );
};